import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import Button from "common/core/button";
import { SupportLink } from "common/core/mailto_link";

import AccountContainer from "./account_container";

function InvalidToken({ context }) {
  const navigate = useNavigate();
  const dashboardBtn = (
    <Button buttonColor="action" variant="primary" onClick={() => navigate("/")}>
      <FormattedMessage id="7dcbc2d9-a00c-4081-a121-77661b29f4b5" defaultMessage="OK" />
    </Button>
  );

  return (
    <AccountContainer>
      <div className="Account--centered">
        <p className="Account-text">
          <span>This {context} link is no longer valid. Please contact </span>
          <SupportLink />
          <span> for more information.</span>
        </p>
        {dashboardBtn}
      </div>
    </AccountContainer>
  );
}

InvalidToken.propTypes = {
  context: PropTypes.string,
};

export default memo(InvalidToken);
